export default __webpack_public_path__ + "static/media/Mendocino.1add3a6e.jpg";